import React, { useState } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Button } from "@atoms";
import { OrderTrackingModal } from "@molecules";
import { useLazyQuery } from "@apollo/react-hooks";
import { tracking } from "@components/TrackingPage/__generated__/tracking";
import { TRACKING_INFORMATION } from "@components/TrackingPage/TrackingPage";

const OrderShippingDetail: React.FC<IProps> = ({
  address,
  fulfillments,
  number,
}: IProps) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [trackingData, setTrackingData] = useState([]);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [isError, setIsError] = useState(true);
  const [trackingUrl, setTrackingUrl] = useState('');
  const [awb, setAwb] = useState('');

  const [fetchTracking, { data, error }] = useLazyQuery<tracking>(
    TRACKING_INFORMATION, {
      onCompleted: async (data) => {
        setLoading(false);
        const parsedData = JSON.parse(data?.tracking?.data ?? "{}");
        if (parsedData['status'] == 'Tracking service is temporarily not available') {
          setIsError(true);
          setTrackingUrl(parsedData.tracking_url ?? '');
          setAwb(parsedData.awb ?? '');
        } else {
          setIsError(false);
          const trackingDetails = parsedData?.data?.tracking_details;
          let trackingData = [];
          if (trackingDetails) {
            trackingData = trackingDetails[trackingNumber].trackingEvents;
          }
          setTrackingData([...trackingData]);
        }
      }
    }
  )

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (trackingNumber: string) => {
    setLoading(true);
    setTrackingNumber(trackingNumber);
    fetchTracking({
      variables: {
        trackingNumber: trackingNumber
      }
    })
    setShowModal(true);
  }

  return (
    <S.Wrapper>
      <OrderTrackingModal
        show={showModal}
        onHide={handleModalClose}
        trackingData={trackingData}
        loading={loading}
        isError={isError}
        tracking_url={trackingUrl}
        awb={awb}
      />
      <S.OrderShippingDetailCard>
        <S.OrderShippingDetailCardHeader>
          <S.OrderShippingDetailCardHeaderTitle>
            Shipping Details
          </S.OrderShippingDetailCardHeaderTitle>
        </S.OrderShippingDetailCardHeader>
        <S.OrderShippingDetailCardBody>
          <Container style={{padding: "0"}}>
            <Row style={{marginTop: "1rem", marginBottom: "1rem"}}>
              <Col>
                <S.OrderShippingDetailMutedSubtitle>
                  Shipping Address
                </S.OrderShippingDetailMutedSubtitle>
              </Col>
            </Row>
            <Row>
              <Col>
                <S.OrderShippingDetailCard>
                  <S.OrderShippingDetailCardBody>
                    <Row>
                      <Col>
                        <S.OrderShippingDetailP>
                          {address.firstName} {address.lastName}
                        </S.OrderShippingDetailP>
                        <S.OrderShippingDetailP>
                          {address.streetAddress1}<br/>
                          {address.streetAddress2}<br/>
                          {address.city}<br/>
                          {address.countryArea}<br/>
                          {address.postalCode}<br/>
                          {address.phone}<br/>
                        </S.OrderShippingDetailP>
                      </Col>
                    </Row>
                  </S.OrderShippingDetailCardBody>
                </S.OrderShippingDetailCard>
              </Col>
            </Row>
          </Container>
          {/* fulfillment loop 시작 */}
          { fulfillments.map((fulfillment, i) => {
            return (
              <Container key={i} style={{padding: "0"}}>
                <Row style={{marginTop: "1rem", marginBottom: "1rem"}}>
                  <Col>
                    <S.OrderShippingDetailMutedSubtitle>
                      Items
                    </S.OrderShippingDetailMutedSubtitle>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <S.OrderShippingDetailCard>
                      <S.OrderShippingDetailCardBody>
                        <Row>
                          <Col>
                            <S.OrderShippingDetailH5>
                              Fulfillment #{number}-{fulfillment.fulfillmentOrder}
                            </S.OrderShippingDetailH5>
                            <S.OrderShippingDetailP>
                              Tracking number: {fulfillment.trackingNumber}<br/>
                              Status: {fulfillment.statusDisplay}
                            </S.OrderShippingDetailP>
                            <Table>
                              <thead>
                                <tr>
                                  <td>Product</td>
                                  <td>Quantity</td>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  fulfillment.lines.map((line, j) => {
                                    return (
                                      <tr key={j}>
                                        <td>{line.orderLine.productName}</td>
                                        <td>{line.orderLine.quantity}</td>
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </Table>
                            {
                              fulfillment.status === 'FULFILLED' &&
                              <Button
                                onClick={
                                  (e:any) => handleModalShow(fulfillment.trackingNumber)}
                              >
                                TRACK BY PACKAGE
                              </Button>
                            }
                          </Col>
                        </Row>
                      </S.OrderShippingDetailCardBody>
                    </S.OrderShippingDetailCard>
                  </Col>
                </Row>
              </Container>
            )
          })}
          {/* fulfillment loop 끝 */}
        </S.OrderShippingDetailCardBody>
      </S.OrderShippingDetailCard>
    </S.Wrapper>
  )
};

export { OrderShippingDetail }